/* ============================================================
   GREAT PRIMATE™ — THEME.JS
   Interactions · v2.0
   ============================================================ */

(function(){
  'use strict';

  /* ---- HELPERS ---- */
  const $  = (s,c) => (c||document).querySelector(s);
  const $$ = (s,c) => [...(c||document).querySelectorAll(s)];

  /* ============================================================
     1. HEADER — scroll show/hide, background
     ============================================================ */
  const header = $('#site-header');
  if(header){
    let lastY = 0, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      if(y > 80) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      if(y > 400 && y > lastY + 5) header.classList.add('is-hidden');
      else if(y < lastY - 5) header.classList.remove('is-hidden');
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => { if(!ticking){ requestAnimationFrame(onScroll); ticking = true; } }, {passive:true});
  }

  /* ============================================================
     2. MOBILE DRAWER
     ============================================================ */
  const drawer    = $('#mobile-drawer');
  const overlay   = $('#drawer-overlay');
  const openBtn   = $('#menu-open');
  const closeBtn  = $('#menu-close');

  function openDrawer(){
    if(!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    openBtn && openBtn.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    openBtn && openBtn.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }
  openBtn  && openBtn.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay  && overlay.addEventListener('click', closeDrawer);

  /* ============================================================
     3. SEARCH OVERLAY
     ============================================================ */
  const searchToggle  = $('#search-toggle');
  const searchOverlay = $('#search-overlay');
  const searchClose   = $('#search-close');
  const searchInput   = $('#search-input');

  function openSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden','false');
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }
  function closeSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden','true');
  }
  searchToggle && searchToggle.addEventListener('click', openSearch);
  searchClose  && searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', e => { if(e.key === 'Escape'){ closeSearch(); closeDrawer(); closeSizeGuide(); } });

  /* ============================================================
     4. MEGA MENU — keyboard + touch accessibility
     ============================================================ */
  const megaDrop = $('.nav-drop--mega');
  const megaMenu = $('#mega-menu');
  if(megaDrop && megaMenu){
    let closeTimer;
    megaDrop.addEventListener('mouseenter', () => { clearTimeout(closeTimer); megaMenu.classList.add('is-open'); });
    megaDrop.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => megaMenu.classList.remove('is-open'), 200); });
    const dropLink = $('.nav-link--drop', megaDrop);
    if(dropLink){
      dropLink.addEventListener('focus', () => megaMenu.classList.add('is-open'));
    }
  }

  /* ============================================================
     5. PRODUCT GALLERY — thumbnail click
     ============================================================ */
  const galleryMain   = $('.gp-product__gallery-main img');
  const galleryThumbs = $$('.gp-product__gallery-thumb');
  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const img = $('img', thumb);
      if(galleryMain && img){
        galleryMain.src    = img.dataset.full || img.src.replace(/width=\d+/, 'width=800');
        galleryMain.srcset = '';
      }
    });
  });

  /* ============================================================
     6. PRODUCT — VARIANT SELECTOR
     ============================================================ */
  $$('.gp-product__option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.gp-product__options');
      if(group){
        $$('.gp-product__option-btn', group).forEach(b => b.classList.remove('is-selected'));
      }
      btn.classList.add('is-selected');
    });
  });

  /* ============================================================
     7. PRODUCT — QUANTITY SELECTOR
     ============================================================ */
  $$('.gp-product__qty').forEach(wrap => {
    const input = $('input', wrap);
    const minus = $('[data-qty="minus"]', wrap);
    const plus  = $('[data-qty="plus"]', wrap);
    if(!input) return;
    minus && minus.addEventListener('click', () => { const v = parseInt(input.value)||1; input.value = Math.max(1, v-1); });
    plus  && plus.addEventListener('click',  () => { const v = parseInt(input.value)||1; input.value = v+1; });
  });

  /* ============================================================
     8. PRODUCT — STICKY ATC BAR
     ============================================================ */
  const mainATC   = $('.gp-product__atc');
  const stickyATC = $('.gp-product__sticky-atc');
  if(mainATC && stickyATC){
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        stickyATC.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold:0 });
    obs.observe(mainATC);
  }

  /* ============================================================
     9. PRODUCT — ACCORDION
     ============================================================ */
  $$('.gp-product__accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const inner   = content && $('.gp-product__accordion-content-inner', content);
      const isOpen  = trigger.classList.contains('is-open');
      // Close all
      $$('.gp-product__accordion-trigger').forEach(t => {
        t.classList.remove('is-open');
        const c = t.nextElementSibling;
        if(c) c.style.maxHeight = '0';
      });
      // Toggle current
      if(!isOpen && content && inner){
        trigger.classList.add('is-open');
        content.style.maxHeight = inner.offsetHeight + 'px';
      }
    });
  });

  /* ============================================================
     10. SIZE GUIDE MODAL
     ============================================================ */
  const sizeGuideModal = $('.size-guide-modal');
  function openSizeGuide(){
    if(!sizeGuideModal) return;
    sizeGuideModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide(){
    if(!sizeGuideModal) return;
    sizeGuideModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  $$('.gp-product__size-guide').forEach(el => el.addEventListener('click', openSizeGuide));
  if(sizeGuideModal){
    $('.size-guide-modal__close', sizeGuideModal)?.addEventListener('click', closeSizeGuide);
    sizeGuideModal.addEventListener('click', e => { if(e.target === sizeGuideModal) closeSizeGuide(); });
  }

  /* ============================================================
     11. COLLECTION — FILTER PILLS
     ============================================================ */
  const filterPills = $$('.gp-collection__filter-pill');
  const productCards = $$('.gp-collection__grid .product-card');
  filterPills.forEach(pill => {
    pill.addEventListener('click', () => {
      const tag = pill.dataset.tag;
      // Toggle active state
      filterPills.forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      // Filter cards
      productCards.forEach(card => {
        if(!tag || tag === 'all'){
          card.style.display = '';
        } else {
          const cardTags = (card.dataset.tags || '').toLowerCase();
          card.style.display = cardTags.includes(tag.toLowerCase()) ? '' : 'none';
        }
      });
    });
  });

  /* ============================================================
     12. COLLECTION — GRID/LIST VIEW TOGGLE
     ============================================================ */
  const viewBtns = $$('.gp-collection__view-btn');
  const collGrid = $('.gp-collection__grid');
  viewBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      viewBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if(collGrid){
        collGrid.classList.toggle('gp-collection__grid--list', btn.dataset.view === 'list');
      }
    });
  });

  /* ============================================================
     13. ADD TO CART — AJAX
     ============================================================ */
  $$('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('button[type="submit"]', form);
      const variantId = $('[name="id"]', form)?.value;
      const qty = $('[name="quantity"]', form)?.value || 1;
      if(!variantId) return;

      btn && (btn.disabled = true, btn.textContent = 'Adding…');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: parseInt(qty) }] })
        });
        if(!res.ok) throw new Error('Add to cart failed');
        const data = await res.json();
        showToast(data.items?.[0]?.title ? `${data.items[0].title} added to cart` : 'Added to cart');
        // Update cart badge
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const badge = $('#cart-badge');
        if(badge) badge.textContent = cart.item_count;
        else {
          const cartIcon = $('a[aria-label*="Cart"]');
          if(cartIcon){
            const span = document.createElement('span');
            span.className = 'cart-badge';
            span.id = 'cart-badge';
            span.textContent = cart.item_count;
            cartIcon.appendChild(span);
          }
        }
      } catch(err) {
        showToast('Could not add to cart. Please try again.');
        console.error(err);
      } finally {
        btn && (btn.disabled = false, btn.textContent = 'Add to Cart');
      }
    });
  });

  /* ============================================================
     14. TOAST NOTIFICATION
     ============================================================ */
  const toast = $('#toast');
  let toastTimer;
  function showToast(msg){
    if(!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
  }

  /* ============================================================
     15. SCROLL REVEAL (IntersectionObserver)
     ============================================================ */
  const revealEls = $$('.reveal');
  if(revealEls.length){
    const revealObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if(e.isIntersecting){
          e.target.classList.add('is-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold:0.1, rootMargin:'0px 0px -40px 0px' });
    revealEls.forEach(el => revealObs.observe(el));
  }

  /* ============================================================
     16. PAGE TRANSITIONS
     ============================================================ */
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href]');
    if(!link) return;
    const url = link.getAttribute('href');
    // Only intercept internal navigation links
    if(!url || url.startsWith('#') || url.startsWith('javascript') || url.startsWith('mailto') || url.startsWith('tel') || link.target === '_blank' || e.ctrlKey || e.metaKey) return;
    if(url.startsWith('http') && !url.includes(window.location.hostname)) return;
    e.preventDefault();
    document.body.classList.add('is-loading');
    setTimeout(() => { window.location.href = url; }, 250);
  });
  window.addEventListener('pageshow', () => {
    document.body.classList.remove('is-loading');
  });

  /* ============================================================
     17. LAZY LOAD IMAGES (native + blur placeholder)
     ============================================================ */
  $$('img[loading="lazy"]').forEach(img => {
    if(img.complete) img.classList.add('is-loaded');
    else img.addEventListener('load', () => img.classList.add('is-loaded'), {once:true});
  });

})();
